import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const fillTemplate = (data) => ({
  info: {
    title: `Indicação de Petição - Solicitação ID: ${data.requestId.text}`,
    name: 'Indicação de Petição',
    author: 'Facilita Jurídico',
    subject: 'Documento da Indicação de Petição'
  },
  content: [
    {
      columns: [
        {
          text: "Indicação de Petição",
          fontSize: 15,
          bold: true,
          alignment: "left",
          color: "#13378d",
          marginTop: 10,
          marginRight: 15,
          marginBottom: 5,
        },
        {
          image:
            "data:image/png;base64,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",
          width: 35,
          absolutePosition: { x: 525, y: 25 },
        },
      ],
      marginBottom: 5,
    },
    {
      columns: [
        [
          {
            text: data.modality.title,
            fontSize: 8,
            marginBottom: 2,
            color: "#444",
          },
          {
            text: data.modality.text,
            bold: true,
            fontSize: 10,
            color: "#13378d",
            marginBottom: 8,
          }
        ],
        [
          {
            text: data.requestId.title,
            fontSize: 8,
            marginBottom: 2,
            color: "#444",
          },
          {
            text: data.requestId.text,
            bold: true,
            fontSize: 10,
            color: "#13378d",
            marginBottom: 8,
          },
        ],
      ],
    },
    ...data.body.map(item =>
      [{
        marginTop: 10,
        text: item.title,
        style: "subheader",
      },
      {
        marginTop: 2,
        style: "text",
        text: `${item.text?.trim()}`,
      }],
    ),
    {
      marginTop: 20,
      text: 'Qualificação das partes',
      style: "subheader",
      fontSize: 13,
      alignment: "left",
      color: "#13378d",
    },
    ...data.partsContent.map(item =>
      [{
        marginTop: 10,
        text: item.title,
        style: "subheader1",
      },
      {
        marginTop: 2,
        style: "text",
        text: `${item.text?.trim()}`,
      }],
    )
  ],
  styles: {
    header: {
      fontSize: 15,
      bold: true,
    },
    subheader: {
      fontSize: 12,
      bold: true,
      color: "#13378d",
    },
    subheader1: {
      fontSize: 11,
      bold: true,
      color: "#444",
    },
    text: {
      fontSize: 10,
      color: "#444",
    },
    quote: {
      italics: true,
    },
    small: {
      fontSize: 8,
    },
  },
});

const prepareDataToPdf = (data) => ({
  requestId: {
    title: 'ID da Solicitação',
    text: data.requestId
  },
  modality: {
    title: 'Modalidade',
    text: data.modality
  },
  body: [
    {
      title: 'Tipo de ação',
      text: (data.typeAction || [])[0]?.optionName || 'Não configurado'
    },
    { title: 'Breve relato do caso', text: data.facts || 'Não Configurado' },
    { title: 'Principais tópicos da petição', text: data.petitionTopics || 'Não Configurado' },
    { title: 'Dados do advogado subscritor', text: data.attorney || 'Não Configurado' }
  ],
  partsContent: data.parts.map(item => ({
    title: `${item.partTypeName} ${item.isRepresented ? " - Parte representada" : ""}`,
    text: item.value
  })
  )
})

const downloadPdf = async (data) => {
  var win = window.open('', '_blank');

  const template = fillTemplate(prepareDataToPdf(data))

  pdfMake.createPdf(template).open({}, win)
}

export default {
  downloadPdf,
}